import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Button } from "components/ui/v2";
import useSound from "use-sound";

const ToggleTheme = () => {
  const [isToggleThemeEnable, setIsToggleThemeEnable] = useState<boolean>(true);
  const { theme, setTheme } = useTheme();
  const [playComplete] = useSound("/sounds/switch-on.mp3", { volume: 0.25 });

  useEffect(() => {
    setTimeout(() => {
      setIsToggleThemeEnable(true);
    }, 1000);
  }, [theme]);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    playComplete();
  };

  return (
    <Button
      variant="ghost"
      shape="circle"
      aria-label="Toggle theme"
      className="h-10 w-10 rounded-full border border-slate-200/70 bg-white/70 text-slate-600 shadow-sm backdrop-blur-sm transition hover:bg-white hover:shadow dark:border-white/10 dark:bg-white/5 dark:text-zinc-300 dark:hover:bg-white/10"
      disabled={!isToggleThemeEnable}
      onClick={toggleTheme}
      size="md"
    >
      {theme === "dark" && (
        <Moon className="h-4 w-4 animate__animated animate__fadeIn text-gray-700 dark:text-gray-200" />
      )}
      {theme === "light" && (
        <Sun className="h-4 w-4 animate__animated animate__fadeIn text-gray-700 dark:text-gray-200" />
      )}
    </Button>
  );
};
export default ToggleTheme;
